import { createCrudSlice } from 'app/createCrudSlice';
import { newspaperService } from 'services/newspaperService';

const { reducer, thunks } = createCrudSlice({ name: 'newspapers', service: newspaperService });

export const {
  fetch: fetchNewspapers,
  create: createNewspaper,
  update: updateNewspaper,
  remove: deleteNewspaper,
} = thunks;

export default reducer;
